// extracted by mini-css-extract-plugin
module.exports = {"Background":"LoggedInView_Background__VLt8z","LoadingList":"LoggedInView_LoadingList__opxv4","Phone":"LoggedInView_Phone__yhQ_w","Desktop":"LoggedInView_Desktop__cUtoj"};